export default {"src":"/_next/static/media/safety-gear-detection.7917da04.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};